import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const WrapperIntegrationSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary h-[200px] w-full rounded-md md:h-[220px] md:w-[320px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};